// extracted by mini-css-extract-plugin
export default {"snackbarContent":"SnackBar_snackbarContent__m+82R"};